export default __webpack_public_path__ + "static/media/home (1).e022a777.png";